export const AUDIT_EVENT_NAMES: Record<string, string> = {
  'Login': 'Entrada no sistema',
  'PutEditExistingUser': 'Atualização de usuário existente',
  'PostRegisterAccountNewUser': 'Registro de novo usuário',
  'PostSynchronizeStores': 'Sincronizar lojas VTEX',
  'PutUpdateVtexSetting': 'Atualização de configuração - VTEX Account',
  'PostCreateNewVtexSetting': 'Criação de configuração - VTEX Account',
  'DeleteVtexSetting': 'Exclusão de configuração - VTEX Account',
  'UserPersistenceJob': 'Automação da persistência de usuário',
  'PostCreateNewUserGroup': 'Criação de novo grupo de usuário',
  'PutUpdateUserGroup': 'Atualização de grupo de usuário',
  'PutUpdateApplicationSetting': 'Atualização de configuração da aplicação',
  'GetShopSellerFilesFromFtp': 'Busca de arquivos de lote de usuários',
  'PostShopSellerSync': 'Sincronização de vendedor',
  'DeleteShopSellerVtexSync': 'Exclusão de vendedor - MD VTEX',
  'PutUpdateShopSellerVtexSync': 'Atualização de vendedor - MD VTEX',
  'PostCreateShopSellerVtexSync': 'Criação de vendedor - MD VTEX',
  'SendDfdl': 'Reenvio de DFDL',
  'OrderCreateWorkflowIBMReprocessing': 'Criação de workflow de reprocessamento de pedido',
  'OrderWorkflowFeedbackIBMReprocessing': 'Feedback de workflow de reprocessamento de pedido',
  'OrderWorkflowRecompileIBMReprocessing': 'Recompilação de workflow de reprocessamento de pedido',
  'OrderCancelWorkflowIBMReprocessing': 'Cancelamento de workflow de reprocessamento de pedido',
  'RectifyCustomer': 'Correção de cliente'
};

export const AUDIT_ENTITY_NAMES: Record<string, string> = {
  'ADDED': 'Inserido',
  'MODIFIED': 'Alterado',
  'DELETED': 'Excluído'
};

export function auditFriendlyName(actionName: string): string {
  return AUDIT_EVENT_NAMES[actionName] || actionName;
}

export function auditEntityActionName(actionName: string): string {
  return AUDIT_ENTITY_NAMES[actionName] || actionName;
}

export interface AuditEvent {
  id: number;
  referenceId?: string;
  traceId: string;
  ipAddress: string; // can be IPv4 or IPv6
  userId: number;
  userName: string;
  actionName: string;
  startTime: string; // ISO string
  elapsedSeconds: number; // actually milliseconds per requirement
  success: boolean;
}

export interface AuditEventEntityModel extends AuditEvent {
  entities: AuditEventEntityListModel[];
  messages: AuditEventMessageModel[];
}

export interface AuditEventEntityListModel {
  id: number;
  traceId: string;
  userId?: number;
  userEmail?: string;
  ipAddress: string;
  action: string;
  entityName: string;
  eventTime: string;
}

export interface AuditEntityDataModel {
  keys: string;
  entityBefore: string;
  entityAfter: string;
}

export interface AuditEventMessageModel {
  id: number;
  message: string;
  date: string;
}
